import PropTypes from "prop-types";
import React from "react";
import Modal from "../modal";

const id = "modal-update-rep-maximum";

function SubmitForReviewModal(props, { locals }) {
  const { params, query, editExercise, activeUser } = locals;

  return (
    <form
      action={`/actions/cycle/${params.cycleId}/`}
      method="POST"
      data-noreset
    >
      <input type="hidden" name="order" value={query.program} />
      <input type="hidden" name="source" value="review" />
      <Modal name={id} key={id} width="600px">
        <div className="head">
          <h2 className="alt">Submit for Review</h2>
        </div>

        <div className="body">
          <div className="columns">
            <div className="column" data-col="1/1">
              Send your login credentials and name of your program to:{" "}
              <b>info@mystrengthbook.com</b>
            </div>
          </div>
          <p>Close this window to go back to your program overview.</p>
        </div>

        <div className="foot">
          <div className="columns">
            <div className="column" data-col="1/1">
              <p>
                <b>ADMIN USE ONLY</b>
              </p>
            </div>
            <div className="column" data-col="1/2">
              <input
                className="text-input"
                type="password"
                name="password"
                placeholder="Admin password"
              />
            </div>
            <div className="column" data-col="1/2">
              <button className="button-input" type="submit">
                Approve
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </form>
  );
}

SubmitForReviewModal.contextTypes = { locals: PropTypes.object };

export { id };
export { SubmitForReviewModal as default };
